import React from 'react';
import { InstagramIcon, FacebookIcon, PinIcon, StarIcon } from 'lucide-react';
import { Ornament } from './Ornament';
export function Footer() {
  return <footer className="bg-charcoal texture-grain text-cream pt-20 pb-10 px-6" data-id="element-44">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-45">
        <div className="flex justify-center mb-16" data-id="element-46">
          <Ornament variant="flourish" color="#FAF7F2" opacity={0.2} className="w-40" data-id="element-47" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16" data-id="element-48">
          {/* Brand Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-49">
            <h3 className="font-serif text-2xl tracking-[0.2em] uppercase mb-4 text-white" data-id="element-50">
              Copper Crest
            </h3>
            <p className="text-cream/70 font-light text-sm mb-6 max-w-xs" data-id="element-51">
              An elegant estate for timeless celebrations and unforgettable
              moments.
            </p>
            <address className="not-italic text-cream/70 font-light text-sm" data-id="element-52">
              1234 Heritage Lane
              <br data-id="element-53" />
              Washington State, WA 98101
            </address>
          </div>

          {/* Links Column */}
          <div className="flex flex-col items-center text-center" data-id="element-54">
            <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-copper mb-6" data-id="element-55">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-56">
              {['Our Story', 'Spaces', 'Experience', 'Gallery', 'Contact'].map(link => <li key={link} data-id="element-57">
                    <a href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-cream/80 hover:text-copper transition-colors text-sm tracking-wide" data-id="element-58">
                      {link}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="flex flex-col items-center md:items-end text-center md:text-right" data-id="element-59">
            <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-copper mb-6" data-id="element-60">
              Connect
            </h4>
            <div className="space-y-2 mb-8 text-cream/80 font-light text-sm" data-id="element-61">
              <p data-id="element-62">
                <a href="tel:+1234567890" className="hover:text-copper transition-colors" data-id="element-63">
                  +1 (234) 567-8900
                </a>
              </p>
              <p data-id="element-64">
                <a href="mailto:hello@coppercrest.com" className="hover:text-copper transition-colors" data-id="element-65">
                  hello@coppercrest.com
                </a>
              </p>
            </div>

            <div className="flex space-x-6" data-id="element-66">
              <a href="#" aria-label="Instagram" className="text-cream/80 hover:text-copper transition-colors" data-id="element-67">
                <InstagramIcon className="w-5 h-5" data-id="element-68" />
              </a>
              <a href="#" aria-label="Facebook" className="text-cream/80 hover:text-copper transition-colors" data-id="element-69">
                <FacebookIcon className="w-5 h-5" data-id="element-70" />
              </a>
              <a href="#" aria-label="Pinterest" className="text-cream/80 hover:text-copper transition-colors" data-id="element-71">
                <PinIcon className="w-5 h-5" data-id="element-72" />
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="border-t border-cream/10 pt-10 pb-8" data-id="element-73">
          <div className="flex items-center justify-center gap-8 md:gap-12 flex-wrap" data-id="element-74">
            {/* Google */}
            <div className="flex items-center gap-2" data-id="element-75">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" data-id="element-76">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-77" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-78" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" data-id="element-79" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-80" />
              </svg>
              <span className="text-cream/80 text-xs font-medium" data-id="element-81">4.9</span>
              <div className="flex gap-0.5" data-id="element-82">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-2.5 h-2.5" style={{
                fill: '#FBBC04',
                color: '#FBBC04'
              }} strokeWidth={0} data-id="element-83" />)}
              </div>
            </div>

            <div className="w-[1px] h-4 bg-cream/15" data-id="element-84" />

            {/* The Knot */}
            <div className="flex items-center gap-2" data-id="element-85">
              <span className="font-serif text-xs font-bold" style={{
              color: '#E8554E'
            }} data-id="element-86">
                The Knot
              </span>
              <span className="text-cream/50 text-[10px] tracking-wide uppercase" data-id="element-87">
                Best of 2024
              </span>
            </div>

            <div className="w-[1px] h-4 bg-cream/15" data-id="element-88" />

            {/* WeddingWire */}
            <div className="flex items-center gap-2" data-id="element-89">
              <span className="font-sans text-xs font-bold" style={{
              color: '#00B2A9'
            }} data-id="element-90">
                WeddingWire
              </span>
              <span className="text-cream/50 text-[10px] tracking-wide uppercase" data-id="element-91">
                Couples' Choice
              </span>
            </div>

            <div className="w-[1px] h-4 bg-cream/15" data-id="element-92" />

            {/* Yelp */}
            <div className="flex items-center gap-2" data-id="element-93">
              <span className="font-sans text-xs font-extrabold" style={{
              color: '#D32323'
            }} data-id="element-94">
                yelp
              </span>
              <div className="flex gap-0.5" data-id="element-95">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-2.5 h-2.5" style={{
                fill: '#D32323',
                color: '#D32323'
              }} strokeWidth={0} data-id="element-96" />)}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cream/10 pt-8 flex flex-col items-center text-center gap-3" data-id="element-97">
          <p className="text-cream/40 text-[11px] tracking-[0.3em] uppercase font-light" data-id="element-98">
            Crafted in the Pacific Northwest
          </p>
          <p className="text-xs text-cream/50 font-light tracking-wide" data-id="element-99">
            &copy; {new Date().getFullYear()} Copper Crest. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}